import React from 'react';
import PropTypes from 'prop-types';
import RouteDropdown from './RouteDropdown';

const bem = 'tt-header';
export default class Header extends React.PureComponent {
  render() {
    const props = this.props;
    const { timetables, selectedHeadsign } = props;

    const showDropdown = selectedHeadsign && selectedHeadsign.routes && selectedHeadsign.routes.length > 1;
    const hideInMobile = !!timetables;
    return (
      <div className={`${bem} ${hideInMobile ? 'hidden-mobile' : ''}`}>
        { showDropdown && <div className={`${bem}__dropdown`}><RouteDropdown {...props} /></div> }
        <div className={`${bem}__darkline`} />
      </div>
    );
  }
}

Header.defaultProps = {
  timetables: null,
};
Header.propTypes = {
  selectedHeadsign: PropTypes.object.isRequired,
  searchMode: PropTypes.string.isRequired,
  timetables: PropTypes.array,
};